import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {GoBackwardAction, GoForwardAction} from '../../shared/stores/root-store/actions/video.action';
import {BufferService} from '../../shared/services/buffer.service';
import {Store} from '@ngrx/store';
import VideoState from '../../shared/stores/root-store/video.state';
import {Subject, Subscription} from 'rxjs';
import {debounceTime, map} from 'rxjs/operators';
import {
    selectCurrentTimeFromState,
    selectIsInMobilePreviewMode
} from '../../shared/stores/root-store/selectors/video.selector';

@Component({
    selector: 'eocm-responsive',
    templateUrl: './responsive.component.html',
    styleUrls: ['./responsive.component.scss']
})
export class ResponsiveComponent implements OnInit, OnDestroy {

    @Input() isSplashScreenVisible = false;
    @Input() isInteraction = false;
    @Input() isVideoPlaying = false;

    disabledNavIcons = true;
    forwardText = false;
    backwardText = false;
    isInMobilePreviewMode = false;

    debounce$ = new Subject();
    private debounceSubscription: Subscription;

    constructor(private bufferService: BufferService,
        private store: Store<{ video: VideoState }>) {
    }

    ngOnInit(): void {
        this.debounceSubscription = this.debounce$.pipe(
            debounceTime(3000),
            map(() => {
                this.isSplashScreenVisible = false;
            })
        ).subscribe();

        this.store.select(selectCurrentTimeFromState).subscribe(time => {
            this.disabledNavIcons = time === 0;
        });
        this.store.select(selectIsInMobilePreviewMode).subscribe((isInMobilePreviewMode) => {
            this.isInMobilePreviewMode = isInMobilePreviewMode;
        });

        this.bufferService.$overlayClicked.subscribe((event: MouseEvent) => {
            this.setSplashScreen(event);
        });
    }

    ngOnDestroy(): void {
        this.debounceSubscription.unsubscribe();
    }

    playOrPauseVideo() {
        this.bufferService.playOrPauseVideo(this.isVideoPlaying);
        this.isVideoPlaying = !this.isVideoPlaying;
    }

    playVideo($event: MouseEvent) {
        $event.stopPropagation();
        this.bufferService.playVideo();
    }

    goBackwards() {
        this.backwardText = true;

        setTimeout(() => {
            this.backwardText = false;

            this.store.dispatch(GoBackwardAction());
        }, 400);
    }

    goForward() {
        this.forwardText = true;

        setTimeout(() => {
            this.forwardText = false;

            this.store.dispatch(GoForwardAction());
        }, 400);
    }

    setSplashScreen(event: MouseEvent) {
        event.stopPropagation();
        this.isSplashScreenVisible = true;

        this.debounce$.next(undefined);
    }

    stopVideo() {
        this.bufferService.stopVideo();
    }
}
